import {CURRENT_ROW_OBJECT, ResponsiveTableColumnsDefinition} from '@aviary/components/table/table.component.types';
import {CombinedCoverTitleDetailComponent} from '@lib/components/combined-cover-title-detail/combined-cover-title-detail.component';
import {ColumnDefinition} from '@store/aviary/aviary.adapter';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {Hold} from '@store/holds/holds.types';
import {CombinedTitleDetailsPositionColumnComponent} from '@app/my-account/holds/table-column-components/combined-title-details-position-column.component';
import {HoldStatusColumnComponent} from '@app/my-account/holds/table-column-components/hold-status-column.component';
import {HoldPositionComponent} from '@app/my-account/holds/hold-position/hold-position.component';
import {CombinedHoldStatusActionsColumnComponent} from '@app/my-account/holds/table-column-components/combined-status-actions-column.component';

type HoldSelectorBucket = typeof HoldsSelectors.OnHold | typeof HoldsSelectors.DependentOnHold;

export function getHoldsTableColumnsDefinition(showActions: boolean): ColumnDefinition<Hold, HoldSelectorBucket>[] {
  return [
    {
      type: 'component',
      columnName: 'item',
      componentClass: CombinedCoverTitleDetailComponent,
      componentProperties: {
        catalogRecord: 'minimalCatalogRecordFor'
      }
    },
    {
      type: 'component',
      columnName: 'itemMd',
      header: 'Item',
      componentClass: CombinedCoverTitleDetailComponent,
      componentProperties: {
        catalogRecord: 'minimalCatalogRecordFor',
        detail1: 'materialTypeDescriptionFor',
        detail2: 'pickupBranchNameFor'
      }
    },
    {
      type: 'component',
      columnName: 'itemSm',
      componentClass: CombinedTitleDetailsPositionColumnComponent,
      componentProperties: {
        hold: CURRENT_ROW_OBJECT,
        catalogRecord: 'minimalCatalogRecordFor'
      }
    },
    {
      type: 'text',
      value: 'materialTypeDescriptionFor',
      header: 'Material Type',
      overrideColumnName: 'materialType',
      headerCssClasses: 'w-[18%]',
      truncate: true
    },
    {
      type: 'text',
      value: 'pickupBranchNameFor',
      header: 'Pick up at',
      overrideColumnName: 'pickUpAt',
      headerCssClasses: 'w-[15%]',
      truncate: true
    },
    {
      type: 'component',
      columnName: 'status',
      componentClass: HoldStatusColumnComponent,
      componentProperties: {
        hold: CURRENT_ROW_OBJECT
      },
      headerCssClasses: 'w-[9rem]',
    },
    {
      type: 'component',
      columnName: 'holdPosition',
      componentClass: HoldPositionComponent,
      componentProperties: {
        status: 'statusFor',
        queueIndex: 'queueIndexAsStringFor',
        copiesCount: 'circulatingCopiesFor',
        forHoldsTable: true
      },
      headerCssClasses: 'w-[7rem]'
    },
    {
      type: 'component',
      columnName: 'combinedStatusAndActions',
      componentClass: CombinedHoldStatusActionsColumnComponent,
      componentProperties: {
        hold: CURRENT_ROW_OBJECT,
        editEnabled: HoldsSelectors.Stateless.isEditable,
        showActions
      },
      headerCssClasses: 'w-[9rem]',
    }
  ];
}

export const ON_HOLD_TABLE_RESPONSIVE_DEFINITION: ResponsiveTableColumnsDefinition = {
  columnNamesSm: ['itemSm', 'combinedStatusAndActions'],
  columnNamesMd: ['itemMd', 'status', 'holdPosition'],
  columnNamesLg: ['item', 'materialType', 'pickUpAt', 'status', 'holdPosition'],
  omitActionsSm: true,
  responsiveHideHeaderRow: true
};
